<!-----------------------------------------------------------------------------
  Copyright (c) 2016 - 2021.                                                  -
  Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)           -
  All Rights Reserved.                                                        -
                                                                              -
  The software and data contained herein are confidential and proprietary     -
  information of Yega Yazilim ("Confidential Information").                   -
                                                                              -
  Users of this software may not disclose such Confidential Information and   -
  shall use it only in accordance with the terms of the license agreement     -
  they entered into with Yega Yazilim.                                        -
                                                                              -
  Author:  Ahmet Dogramaci                                                    -
  Date:    2021-02-25                                                         -
  ----------------------------------------------------------------------------->

<template>
  <div class="mb-3">
    <b-row v-for="item in sorted_items" :key="item.id">
      <b-col sm="12" md="12" lg="12" xl="12" >
        <slot name="cardbody" v-bind:item="item">
          <b-card no-body>
            <b-card-body class="py-2">
              <div class="d-flex justify-content-between">
                <h4 class="text-danger">{{ item.attribute_store['short-name'] }}</h4>
                <b-button variant="link" :to="{name:getConfigurePathName(item), params: {template_id:item.id}}">{{ item.attribute_store['long-description'] }}</b-button>
              </div>
            </b-card-body>
          </b-card>
        </slot>
      </b-col>
    </b-row>
    <yega1-axios-data-source ref="data_source"
                             store-name="ConfigurationTemplatesStore"
                             :store-query="{attribute_query_hash:{'is_listed':'YES','is_accessory':'YES'}}"></yega1-axios-data-source>
  </div>
</template>

<script>
import Yega1AxiosDataSource from "../yega/yega1/yega1-axios-data-source.vue";
export default {
name: "accessories-list",
  components: {Yega1AxiosDataSource},
  provide() {
    return {
      setItems: this.setItems,
      registerDataSource: this.registerDataSource,
      registerItemsReceiver: this.registerItemsReceiver
    };
  },
  data() {
    return {
      items_receivers: [],
      filtered_items: [],
      filtered_items_receivers: [],
      items: []
    };
  },
  computed:{
    sorted_items(){
      return this.items.sort((a,b)=>{
        let aVal = a.attribute_store['order'];
        let bVal = b.attribute_store['order'];
        return ('' + aVal).localeCompare('' + bVal);
      });
    }
  },
  methods: {
    setItems(items) {
      this.items = items;
      this.items_receivers.forEach((component) => {
        component.setItems(items);
      });
    },
    registerDataSource(data_source) {
      this.items_data_source = data_source;
    },
    registerItemsReceiver(component) {
      this.items_receivers.push(component);
    },
    getConfigurePathName(template){
      if(template.name === 'Sharp – Laptops In Stock'){
        return 'configure_featured_skus_path';
      }else if(template.name === 'Sharp - Laptop Services'){
        return 'configure_services_path';
      }else{
        return 'configure_accessories_path';
      }
    }
  }
}
</script>

<style scoped>

</style>
